const sportsFiCookieDomainSuffixes = [
  'local.sportsfi.tech',
  'dev.sportsfi.tech',
  'stg.sportsfi.tech',
  'sportsfi.tech',
  'sportsfi.com',
];

function normalizeHostname(hostnameOrHost?: string | null): string | null {
  if (hostnameOrHost == null || hostnameOrHost.length === 0 || hostnameOrHost.startsWith('[')) {
    return null;
  }

  return hostnameOrHost.toLowerCase().replace(/:\d+$/u, '').replace(/\.$/u, '');
}

export function getSharedSportsFiCookieDomain(hostnameOrHost?: string | null): string | undefined {
  const hostname = normalizeHostname(hostnameOrHost);
  const configuredCookieDomain = process.env.NEXT_PUBLIC_COOKIE_DOMAIN ?? process.env.NEXTAUTH_COOKIE_DOMAIN;

  if (
    configuredCookieDomain != null &&
    configuredCookieDomain.length > 0 &&
    (hostname == null || (hostname !== 'localhost' && hostname !== '127.0.0.1'))
  ) {
    return configuredCookieDomain;
  }

  if (hostname == null) {
    return undefined;
  }

  const domainSuffix = sportsFiCookieDomainSuffixes.find((suffix) => {
    return hostname === suffix || hostname.endsWith(`.${suffix}`);
  });

  return domainSuffix == null ? undefined : `.${domainSuffix}`;
}
